import axios from "axios";
import { makeUserLogout } from "utils";
import { LOCAL_STORAGE_KEYS } from "utils/localStorageKeys";

const defaultFunction = async (method) => {
  return new Promise((resolve, reject) => {
    callApi(method, resolve, reject);
  });
};

export default defaultFunction;

export async function callApi(method, resolve, reject) {
  let headers = {
    Accept: "application/json",
    "Content-Type": "multipart/form-data",
    Application: "partner",
  };

  const token = localStorage.getItem(LOCAL_STORAGE_KEYS?.TOKEN);
  if (token) {
    headers.Authorization = `token ${token}`;
  }

  let axiosData = {
    method: method.apiType,
    headers: headers,
    url: method.type,
  };

  if (method.apiType === "GET" || method.apiType === "DELETE") {
    axiosData.timeout = 10000;
  } else {
    if (method.isFile) {
      headers["Content-Type"] = "multipart/form-data";
      var formData = await getFormData(method.payload);
      axiosData.data = formData;
    } else {
      headers["Content-Type"] = "application/json";
      axiosData.data = JSON.stringify(method.payload);
    }
    axiosData.timeout = 20000;
  }

  try {
    let response = await axios(axiosData);
    checkResponse(response, resolve, reject);
  } catch (err) {
    let response = err.response;
    if (response) {
      checkResponse(response, resolve, reject);
    } else {
      reject(err.message ? { error: err.message } : { error: err.message });
      return;
    }
  }
}

function checkResponse(response, resolve, reject) {
  switch (response.status) {
    case 200:
    case 201:
    case 204:
      resolve(response.data || {});
      break;
    case 400:
      reject(response.data);
      break;
    case 401:
      reject(response.data);
      makeUserLogout();
      break;
    case 500:
      reject({ err: response.data?.message || "Internal Server Error" });
      break;
    default:
      reject({ err: response.data?.message || "Unexpected error occurred" });
  }
}

function getFormData(data) {
  let formData = new FormData();
  for (const [key, value] of Object.entries(data)) {
    if (Array.isArray(value) === true) {
      for (var i = 0; i < value?.length; i++) {
        formData.append(`${key}`, value[i]);
      }
    } else {
      formData.append(`${key}`, value);
    }
  }
  return formData;
}
